<template lang="html">
  <div class="SquadDetail ListingCard-item">

    <h3 v-if="squad.name" class="ListingCard-title">
      {{ squad.name }}
    </h3>

    <p class="u-mb1">
      <span v-if="squad.zip">Zip Code: {{ squad.zip }}</span>

      <span v-if="squad.district_id" class="SquadDetail-text">
        District: {{ squad.district_name }}
      </span>

      <span class="SquadDetail-text">
        Squad Leader: {{ squad.firstName }} {{ squad.lastName }}
      </span>

      <span v-if="squad.website" class="SquadDetail-text">
        Website: {{ squad.website }}
      </span>

      <span v-if="squad.distance" class="SquadDetail-text">
        Distance: {{ squad.distance }}
      </span>
    </p>

    <button @click="joinSquad(squad)" type="button" class="Button Button--outline">
      Join This Squad
    </button>

  </div>
</template>

<script>

export default {
  props: {
    squad: {
      type: Object,
      default: {
        district_id: -1,
        name: "Name FIXME",
        firstName: "First",
        lastName: "Last",
        phone: "XXX-XXX-XXXX",
        email: "hello@threespot.com"
      }
    }
  },

  computed: {
    orgainzer: () => {
      return `${this.firstName} ${this.lastName}`;
    }
  },

  methods: {
    joinSquad(squad) {
      this.$store.commit('squadSearch/setSquad', squad);
      this.$store.commit('squadSearch/setJoining', true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// squad-listing-item.vue?692511e2